import { useMemo } from "react";
import { AVAILABLE_COLOR_VARIANTS } from "../constants/colors";
import { isColorVariantValue } from "../logic";
var useTypographyColors = function useTypographyColors(colorString) {
  var result = useMemo(function () {
    return isColorVariantValue(colorString, AVAILABLE_COLOR_VARIANTS);
  }, [colorString, AVAILABLE_COLOR_VARIANTS]);
  return result;
};
export default useTypographyColors;